import React, { useEffect, useRef, useContext } from "react";
import { Link } from "react-router-dom";
import useState from "react-usestateref";
import Header from "./Header";
import "./Landing.css";
import Spline from "@splinetool/react-spline";
import authService from "../services/authservices";
import "../../src/LandingNew.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import "../translate/i18n.js";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";
import {toast} from "react-toastify";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import Footer from "./Footer";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useParams,
  useNavigate,
} from "react-router-dom";

import enUnique from "../assests/landing_dashboard.webp";
import etUnique from "../assests/esto2.png";
import fiUnique from "../assests/finish3.png";
import enOne from "../assests/stack_card_one.webp";
import etOne from "../assests/stack_card_one2.png";
import fiOne from "../assests/stack_card_one3.png";
import enTwo from "../assests/stack_card_Twonew1.webp";
import etTwo from "../assests/stack_card_Twonew2.webp";
import fiTwo from "../assests/stack_card_Twonew3.webp";
import enThree from "../assests/stack_card_two.webp";
import etThree from "../assests/stack_card_two2.png";
import fiThree from "../assests/stack_card_two3.png";
import enFive from "../assests/stack_card_five.webp";
import etFive from "../assests/stack_card_five22.png";
import fiFive from "../assests/stack_card_five33.png";
import enSeven from "../assests/stack_card_seven.webp";
import etSeven from "../assests/stack_card_seven2.png";
import fiSeven from "../assests/stack_card_seven3.png";
import enEight from "../assests/stack_card_eight.webp";
import etEight from "../assests/stack_card_eight2.png";
import fiEight from "../assests/stack_card_eight3.png";
import enAfImage from "../assests/af_img_two.webp";
import etAfImage from "../assests/af_img_two2.png";
import fiAfImage from "../assests/af_img_two3.png";

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Select from "react-select";
import { FallbackFragment } from "ethers";
import Chatbot from "./Chatbot/Chatbot";

// import CookieConsent from "react-cookie-consent";

gsap.registerPlugin(ScrollTrigger);

const packageSelectionOption = [
  { value: 'Premium', label: 'Premium: $15.12 (70–30 split)' },
  { value: 'Pro', label: 'Pro: $20.52 (80–20 split)' },
  { value: 'EliteTrader', label: 'Elite Trader: $28.08 (70–30 split)' }
]
const packages = {
  Premium: { fee: 15.12, trader: 0.7, platform: 0.3 },
  Pro: { fee: 20.52, trader: 0.8, platform: 0.2 },
  EliteTrader: { fee: 28.08, trader: 0.7, platform: 0.3 }
};

const LandingNew2 = () => {
  const { t } = useTranslation();
    const { theme } = useContext(UserContext);
    const [packageSelect, setPackageSelect] = useState()
    const [packageSelectStatus, setPackageSelectStatus] = useState(false)
    
    const customStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: theme === "dark" ? "transparent" : "#f9f9f9",
      padding: "4px",
      color: theme === "dark" ? "#fff" : "#000",
      boxShadow: "none",
      outline: "none",
    }),
    option: (styles, { isFocused }) => ({
      ...styles,
      color: theme === "dark" ? "#fff" : "#000",  
      backgroundColor: isFocused
        ? theme === "dark"
          ? "#444"
          : "#e0e0e0"
        : theme === "dark"
          ? "#181a20"
          : "#fff",
      cursor: "pointer",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: theme === "dark" ? "#fff" : "#000",
    }),
  };

  // const [i18nextLngs, seti18nextLngs] = useState(
  //   localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  // );
  // const { i18nextLng } = useContext(UserContext);
  // console.log(i18nextLng, "usecontext");
  // useEffect(() => {
  //   if (i18nextLng === "en") {
  //     i18n.changeLanguage(i18nextLngs);
  //     document.documentElement.lang = i18nextLngs;
  //     localStorage.setItem("i18nextLng", i18nextLngs);
  //   } else {
  //     i18n.changeLanguage(i18nextLngs);
  //   }
  // }, [i18nextLng]);
  const image = { en: enUnique, et: etUnique, fi: fiUnique };
  const one = { en: enOne, et: etOne, fi: fiOne };
  const two = { en: enTwo, et: etTwo, fi: fiTwo };
  const three = { en: enThree, et: etThree, fi: fiThree };
  const five = { en: enFive, et: etFive, fi: fiFive };
  const seven = { en: enSeven, et: etSeven, fi: fiSeven };
  const eight = { en: enEight, et: etEight, fi: fiEight };
  const afImage = { en: enAfImage, et: etAfImage, fi: fiAfImage };

  // console.log(one, "one");
  const { lang: urlLang } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    getSitedata();
    getAllPlans();
    setLang(urlLang || localStorage.getItem("i18nextLng"));
  }, [urlLang]);
  // console.log(urlLang, "urlLang", localStorage.getItem("i18nextLng"));

  const changeLang = (newLang) => {
    setLang(newLang);
    navigate(`/${newLang === "en" ? "" : newLang}`);
    setShowPopup(false);
    // console.log(newLang, "newLang");
  };

  // Default to "en" if no lang in URL
  const initialLang = urlLang || "en";
  const [lang, setLang] = useState(initialLang);
  // console.log(lang, "lang");

  const [showPopup, setShowPopup] = useState(false);

  const [loginCheck, setloginCheck] = useState(false);
  const [siteDatacomes, setSiteData] = useState("");
  const [subscribePlans, setsubscribePlans] = useState([]);

  const stackCards = [
    {
      title: t("CreateYourAccount"),
      description: t("CreateYourAccountDesc"),
      image: one[lang],
      classSuffix: "one",
    },
    {
      title: t("ApprovethePolicyPack"),
      description: t("ApprovethePolicyPackDesc"),
      image: two[lang],
      classSuffix: "two",
    },
    {
      title: t("DepositFunds"),
      description: t("DepositFundsDesc"),
      titlefiat: t("depositFundList1"),
      fiat_content: t("depositFundList1_def1"),
      fiat_content2: t("depositFundList1_def2"),
      title_crypto: t("depositFundList2"),
      crypto_desc1: t("depositFundList2_def1"),
      crypto_desc2: t("depositFundList2_def2"),
      crypto_desc_list: t("depositUsage_1"),
      crypto_desc_list2: t("depositUsage_2"),
      image: three[lang],
      classSuffix: "three",
    },
    {
      title: t("ChooseSubscriptionPlan"),
      description: t("ChooseSubscriptionPlanDesc"),
      image: require("../assests/stack_card_three.webp"),
      classSuffix: "four",
    },
    {
      title: t("ConnectYourExchange"),
      description: t("ConnectYourExchangeDesc"),
      image: require("../assests/stack_card_four.webp"),
      classSuffix: "five",
    },
    {
      title: t("FillYourFuelWallet"),
      description: t("FillYourFuelWalletDesc"),
      image: five[lang],
      classSuffix: "six",
    },
    {
      title: t("ActivateTheBot"),
      description: t("ActivateTheBotDesc"),
      image: require("../assests/stack_card_six.webp"),
      classSuffix: "seven",
    },
    {
      title: t("TrackYourResults"),
      description: t("TrackYourResultsDesc"),
      image: seven[lang],
      classSuffix: "eight",
    },
    {
      title: t("WithdrawProfitsAnytime"),
      description: t("WithdrawProfitsAnytimeDesc"),
      image: eight[lang],
      classSuffix: "nine",
    },
  ];

  const [card, setcard, cardref] = useState([]);
  useEffect(() => {
    setcard(stackCards);
  }, [stackCards]);

  const getSitedata = async () => {
    try {
      const data = await authService.getsitedata();
      if (data.status == true) {
        setSiteData(data.data);
        // console.log(data, "=-=-=get site datas =-=-", data.data);
      }
    } catch (error) { }
  };


  useEffect(() => {
    let userToken = localStorage.getItem("token");
    if (userToken) {
      setloginCheck(true);
    } else {
      setloginCheck(false);
    }
  }, [0]);

  const getAllPlans = async () => {
    try {
      const data = await authService.getAllPlans();
      if (data.status == true) {
        setsubscribePlans(data.data);
        // console.log(data, "=-=-=get getAllPlans =-=-", data.data);
      }
    } catch (error) { }
  };

  // GSAP animation for stacking cards
  useEffect(() => {
    gsap.utils.toArray(".bn_stack_row").forEach((row, index) => {
      gsap.fromTo(
        row,
        {
          opacity: 0,
          y: 40,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: row,
            start: "top 80%", // when row top hits 80% of viewport
            toggleActions: "play none none reverse",
          },
        }
      );
    });
  }, []);

  // Mouse move effect for card tilt and custom cursor
  const cardRef = useRef(null);
  const cursorRef = useRef(null);

  const handleMouseMove = (e) => {
    const card = cardRef.current;
    const customCursor = cursorRef.current;
    const { width, height, left, top } = card.getBoundingClientRect();

    const x = e.clientX - left;
    const y = e.clientY - top;

    // Tilt effect
    const xRotation = -20 * ((y - height / 2) / height);
    const yRotation = 10 * ((x - width / 2) / width);
    card.style.transform = `perspective(5000px) scale(1.02) rotateX(${xRotation}deg) rotateY(${yRotation}deg)`;

    // Move image cursor
    customCursor.style.left = `${x}px`;
    customCursor.style.top = `${y}px`;
  };

  const handleMouseEnter = () => {
    cursorRef.current.style.display = "block";
  };

  const handleMouseLeave = () => {
    const card = cardRef.current;
    card.style.transform = "perspective(5000px) scale(1) rotateX(0) rotateY(0)";
    cursorRef.current.style.display = "none";
  };

  // Tools
  const [isPrevToolsDisabled, setIsPrevToolsDisabled] = useState(true);
  const [isNextToolsDisabled, setIsNextToolsDisabled] = useState(false);

  const handleToolsChange = (ToolsSwiper) => {
    setIsPrevToolsDisabled(ToolsSwiper.isBeginning);
    setIsNextToolsDisabled(ToolsSwiper.isEnd);
  };

  const [capital, setCapital] = useState(0);
  const [scenario, setScenario] = useState(0);    // percent like 3,5,7
  const [selectedPackage, setSelectedPackage] = useState(null);

  const [grossProfit, setGrossProfit] = useState(0);
  const [traderProfit, setTraderProfit] = useState(0);
  const [platformProfit, setPlatformProfit] = useState(0);
  const [fee, setfee] = useState(0);
  const [breakevenReturn, setBreakevenReturn] = useState(0);
  const [NetProfit, setNetProfit] = useState(0);
  const [NetProfitPrecentage, setNetProfitPrecentage] = useState(0);
  const [usdPrice, setusdPrice] = useState(1.08);

const calculateProfit = (pkg) => {
  if (!capital || !scenario || !pkg) {
    return;};

    // Convert package fee from EURO → USD
    // const subscriptionUSDFees = pkg.fee * usdPrice;
    const subscriptionUSDFees = pkg.fee 
    // Gross = capital × scenario %
    const gross = (capital * scenario) / 100;

    console.log(subscriptionUSDFees,'gross===')
    // Platform share = gross × platform%
    const platformShare = (gross * pkg.platform);
    // Net Profit = gross – platform – subscription fee
    const netProfit = gross - platformShare - subscriptionUSDFees;
    const netProfitPercentage = (netProfit/capital) * 100;
    // Breakeven Return % = Subscription / (Capital × (1 - platform%)) × 100-----------------
    const breakeven =
      (subscriptionUSDFees / (capital * (1 - pkg.platform))) * 100;

    setGrossProfit(gross.toFixed(2));
    setPlatformProfit(platformShare.toFixed(2));
    setfee(subscriptionUSDFees.toFixed(2));
    setBreakevenReturn(breakeven.toFixed(2));
    setNetProfit(netProfit.toFixed(2)); // if needed
    setNetProfitPrecentage(netProfitPercentage.toFixed(2)); // if needed
  };

  return (
    <>
      <Header />

      <main
        className={` ${lang == "en"
          ? "englishLang"
          : lang == "et"
            ? "estonianLang"
            : lang == "fi"
              ? "finnishLang"
              : ""
          } landing_main_wrapper bn-main`}
      >
        {/* hero */}
        <section className="bn-hero" id="home">
          {/* <h1 className="bn-hero-title">
            Let <span className="bn-hero-gradient">Binarge</span> Trade,{" "}
            <div className="capital_fontsize">You own the capital.</div>
            <div className="capital_fontsize"> You own the profits.</div>
          </h1> */}
          <h1 className="bn-hero-title">
            {t("Automated")}
            <span className="bn-hero-gradient"> {t("Crypto")} </span>
            {t("Trading")}
            <div className="capital_fontsize">
              {t("WithoutGivingAwayYourFunds")}
            </div>
            {/* <div className="capital_fontsize"> You own the profits.</div> */}
          </h1>
          <p className="bn-hero-content">{t("LetBinargeTrade247")}</p>

          <div className="bn-hero-btn-wrap">
            {loginCheck ? (
              <Link className="bn-landing-btn" to="/home">
                {t("JoinTheCommunity")}
                <span className="bn-landing-btn-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </Link>
            ) : (
              <Link className="bn-landing-btn" to="/register">
                {t("JoinTheCommunity")}
                <span className="bn-landing-btn-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </Link>
            )}
          </div>
          <div className="bn-hero-animate">
            <Spline
              scene="https://prod.spline.design/x7mfluxqcknKWdbY/scene.splinecode"
              className="bn-hero-anim"
            />
            <Spline
              scene="https://prod.spline.design/yNbEm8JnABORMNnf/scene.splinecode"
              className="bn-hero-anim-mob"
            />
          </div>
          <div className="bn-logo-hide"></div>
          <div className="bn-logo-hide-mob"></div>
        </section>

        <section className="Prft_Simul_sct">
          <div className="container-fluid container-lg">
            <div className="Prft_Simul_wrp">
              <div className="Prft_Simul_cntcol">
                <h5>Binarge Profit Simulator</h5>
                <p>Calculate your hypothetical trading profits with our premium packages</p>
              </div>
              <div className="Prft_Simul_crdcol">
                <h4>Profit Simulator</h4>

                <div className="Prft_Simul_crdFrm">
                  <div className="Prft_Simul_crdInpwrp">
                    <label>Estimated Capital (USD)</label>
                   <input
  type="number"
  placeholder="E.g. 1000"
  onKeyDown={(e) => {
    if (["e", "E", "+", "-","up","down"].includes(e.key)) {
      e.preventDefault(); // restrict invalid chars
    }
  }}
  onWheel={(e) =>
                                              e.currentTarget.blur()
                                            }
  onChange={(e) => {
    console.log(e.target.value,"e.target.value")
    if(e.target.value==""){
      setCapital('')
      setPackageSelectStatus(false);
    }
    setCapital(Number(e.target.value));
    if (selectedPackage) calculateProfit(packages[selectedPackage]);
  }}
/>

                  </div>
                  <div className="Prft_Simul_checkmain">
                    <label>Scenario Selection</label>
                    <div className="Prft_Simul_checkwrp">
                      <div className="Prft_Simul_checkBox">
                        <label class="Prft_Simul_checkCont" onClick={() => { setScenario(3); calculateProfit(packages[selectedPackage]); }}>Conservative (3%)
                          <input type="radio" name="radio" />
                          <span class="Prft_Simul_checkmrk"></span>
                        </label>
                      </div>
                      <div className="Prft_Simul_checkBox" onClick={() => { setScenario(5); calculateProfit(packages[selectedPackage]); }}>
                        <label class="Prft_Simul_checkCont">Standard (5%)
                          <input type="radio" name="radio" />
                          <span class="Prft_Simul_checkmrk"></span>
                        </label>
                      </div>
                      <div className="Prft_Simul_checkBox" onClick={() => { setScenario(7); calculateProfit(packages[selectedPackage]); }}>
                        <label class="Prft_Simul_checkCont">Optimistic (7%)
                          <input type="radio" name="radio" />
                          <span class="Prft_Simul_checkmrk"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="Prft_Simul_crdInpwrp">
                    <label>Package Selection</label>
                    <Select
                      options={packageSelectionOption}
                      styles={customStyles}
                      placeholder="Choose Package"
                      onChange={(e) => {
                        setSelectedPackage(e.value);
                        const pkg = packages[e.value];
                        calculateProfit(pkg);
                      }}
                      className="package-dropdown-menu"
                    />

                  </div>
                </div>

                {packageSelectStatus ?
                  (<div className="Prft_Simul_crdWrp">
                    <h5
                      className={
                        NetProfitPrecentage > 1
                          ? "text-green"
                          : NetProfitPrecentage > 0
                            ? "text-yellow"
                            : "text-red"
                      }
                    >
                      ${NetProfit ?? 0} ({NetProfitPrecentage ?? 0}%)
                    </h5>
                    <div className="Prft_Simul_crdlst">
                      <div className="Prft_Simul_crditm">
                        <div className="Prft_Simul_crditmIn">
                          <h6>${grossProfit ? grossProfit : 0} </h6>
                          <p>Gross Profit</p>
                        </div>
                      </div>
                      <div className="Prft_Simul_crditm">
                        <div className="Prft_Simul_crditmIn">
                          <h6>${platformProfit ? platformProfit : 0}</h6>
                          <p>Binarge Share</p>
                        </div>
                      </div>
                      <div className="Prft_Simul_crditm">
                        <div className="Prft_Simul_crditmIn">
                          <h6>${fee ? fee : 0}</h6>
                          <p>Subscription Fee</p>
                        </div>
                      </div>
                      <div className="Prft_Simul_crditm">
                        <div className="Prft_Simul_crditmIn">
                          <h6>{breakevenReturn ? breakevenReturn : 0}%</h6>
                          <p>Breakeven Return %</p>
                        </div>
                      </div>
                    </div>
                  </div>) : null
                }
{!selectedPackage || !capital?
  <button className="CalPrft_btn" >Calculate Profit</button>:
    <button className={`CalPrft_btn ${selectedPackage? 'CalPrft_btnActive': ''}`} onClick={()=>{setPackageSelectStatus(true);}}>Calculate Profit</button>
}
                <p className="CalPrft_descrp">This calculator is a hypothetical simulation tool. Binarge cannot see your real funds and does not provide investment advice.</p>

              </div>
            </div>
          </div>
        </section>

        {/* stacking cards */}
        <section className="bn_stakecard_outer" id="how-it-works">
          <div className="container-fluid container-md">
            {/* Language icon */}
            {/* <div style={{ position: "relative" }}>
        <button
          style={{
            background: "transparent",
            border: "1px solid white",
            color: "white",
            padding: "8px",
            cursor: "pointer",
            borderRadius: "5px",
          }}
          onClick={() => setShowPopup(!showPopup)}
        >
          🌐
        </button>

        {showPopup && (
          <div
            style={{
              position: "absolute",
              top: "40px",
              left: 0,
              background: "#333",
              border: "1px solid white",
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            <p style={{ cursor: "pointer",color:"#ffff" }} onClick={() => changeLang("en")}>
              English
            </p>
            <p style={{ cursor: "pointer",color:"#ffff" }} onClick={() => changeLang("et")}>
              Eesti
            </p>
            <p style={{ cursor: "pointer",color:"#ffff" }} onClick={() => changeLang("fi")}>
              Suomi
            </p>
          </div>
        )}
      </div> */}

            {/* Content */}

            <h3 className="bn_ln_subtitle bn_stack_title">
              {t("LetTheBotTrade")}
            </h3>
            <p className="bn_stack_content">{t("BinargeIntro")}</p>

            <div className="bn_stack_container">
              {cardref.current.map((card, index) => {
                // console.log(card,"000000")
                return (
                  <div
                    key={index}
                    className={`row g-3 bn_stack_row bn_stack_rownew bn_stack_rw_${card.classSuffix}`}
                  >
                    <div className="col-xl-5 col-sm-6 text-center bn_stack_col1new">
                      <img src={card.image} alt="" className="bn_stack_img" />
                    </div>
                    <div className="col-xl-7 col-sm-6 bn_stack_col2new">
                      {
                        index == 2 ? (
                          <div className="bn_stack_rgt">
                            <h5>{card.title}</h5>
                            <p className="card_descr">{card.description}</p>
                            <h6 className="card_title_stack2">{card.titlefiat}</h6>
                            <p className="card_para_content">{card.fiat_content}</p>
                            <p className="card_para_content">{card.fiat_content2}</p>
                              <h6 className="card_title_stack2">{card.title_crypto}</h6>
                                <p className="card_para_content">{card.crypto_desc1}</p>
                                  <p className="card_para_content">{card.crypto_desc2}</p>
                                  <ul className="card-crypto_des_list">
                                    <li className="card_para_content">{card.crypto_desc_list}</li>
                                    <li className="card_para_content">{card.crypto_desc_list2}</li>
                                  </ul>

                              



                          </div>
                      //   title: t("DepositFunds"),
                      // // description: t("DepositFundsDesc"),
                      // // titlefiat : t("depositFundList1"),
                      // // fiat_content : t("depositFundList1_def1"),
                      // // fiat_content : t("depositFundList1_def2"),
                      // // title_crypto : t("depositFundList2"),
                      // // crypto_desc1 : t("depositFundList2_def1"),
                      // // crypto_desc2 : t("depositFundList2_def2"),
                      // // crypto_desc_list : t("depositUsage_1"),
                      // // crypto_desc_list2 : t("depositUsage_2"),
                      // // image: three[lang],
                      // // classSuffix: "three",
                      ) :
                      <div className="bn_stack_rgt">
                        <h5>{card.title}</h5>
                        <p>{card.description}</p>
                      </div>
                      }
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* about */}
        <section className="bn_abt_nw">
          <div className="container-fluid container-xl">
            <h3 className="bn_ln_subtitle bn_abt_nw_title">
              {t("WhatIsBinargeBot")}
            </h3>
            <p className="bn_abt_content">{t("BinargeDescription")}</p>
            <div
              className="bn_abt_img_wrap"
              ref={cardRef}
              onMouseMove={handleMouseMove}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <img src={image[lang]} alt="" className="bn_ln_dashboard" />

              <img
                src={require("../assests/custom_cursor.webp")}
                alt="custom-cursor"
                ref={cursorRef}
                className="custom_cursor"
              />
            </div>

            <div className="row g-lg-3 g-4 mx-0 bn_feature_row">
              <div className="col-lg-4 col-sm-6">
                <div className="bn_fe_card_nw bn_fe_br">
                  <img src={require("../assests/fe_img_one.webp")} alt="" />
                  <h5>{t("LowRiskStrategies")}</h5>
                  <p>{t("LowRiskDescription")}</p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="bn_fe_card_nw bn_fe_br bn_br_md_none">
                  <img src={require("../assests/fe_img_two.webp")} alt="" />
                  <h5> {t("MultipleExchangesOneBot")}</h5>
                  <p>{t("BinargeConnectsTopExchanges")}</p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="bn_fe_card_nw">
                  <img src={require("../assests/fe_img_three.webp")} alt="" />
                  <h5>{t("QuickSetup")}</h5>
                  <p>{t("QuickSetupDescription")}</p>
                </div>
              </div>

              <div className="bn_grad_rt_wrap">
                <div className="bn_grad_rt_outer">
                  <div className="bn_grad_rt_inner">
                    {t("OtherInterestingFeatures")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* choose plan */}
        <section className="bn_ch_plan" id="pricing">
          <div className="container-fluid container-xl">
            <h3 className="bn_ln_subtitle bl_pl_title">
              {t("ChooseAPlanThatMatchesYourTradingGoals")}
            </h3>
            <p className="bn_abt_content text-center">
              {t("SimplePricingScalablePlansCancelAnytime")}
            </p>

            <div className="row g-lg-5 g-4 bn_pln_row">
              {subscribePlans.length > 0 ? (
                <>
                  <div className="col-xl-5 col-md-6 bn-pn-col">
                    <div className="bn-pln-col">
                      <div className="bn-plan-card-outer">
                        <div className="bn-plan-card-inner">
                          <div>
                            <div className="text-center">
                              <img
                                src={require("../assests/freemium.webp")}
                                alt="freemium"
                                className="bn-plan-card-img"
                              />
                            </div>
                            <h3 className="bn-pln-cd-title bn-freemium">
                              {subscribePlans[0].subscriptionName}
                            </h3>
                            <div className="bn-pln-subtitle-wrap">
                              <h6 className="bn-pln-lft-title">
                                {t("Free")} <span></span>
                              </h6>

                              <p className="bn-pln-rgt-content">
                                {t("Free")} {subscribePlans[0].subdays} Days
                              </p>
                            </div>
                            <p className="bn-pln-rgt-content mt-3">
                              {" "}
                              {/* {t("AndCompliance")}{" "}
                              <span className="bn-freemium">
                                {" "}
                                {t("Paddle")}
                              </span>{" "}
                              {t("ProcessesAllPaymentsSecurely")} */}
                              {t("TrustAndCompliance")}
                              <br />
                              {/* {t("PaddleProcessesPayments")} */}
                            </p>
                            <div className="bn_pln_details_outer">
                              <div className="bn-pln-details-wrap">
                                <div className="bn-pln-dt-flx">
                                  <span className="bn-plan-check bn-plan-fr">
                                    <i className="fa-solid fa-check"></i>
                                  </span>

                                  <p className="bn-plan-details-content">
                                    <span className="bn-freemium">
                                      {t("Strategies")}
                                    </span>{" "}
                                    {subscribePlans[0].Strategies}
                                  </p>
                                </div>
                                <div className="bn-pln-dt-flx">
                                  <span className="bn-plan-check bn-plan-fr">
                                    <i className="fa-solid fa-check"></i>
                                  </span>

                                  <p className="bn-plan-details-content">
                                    <span className="bn-freemium">
                                      {t("Exchanges")}
                                    </span>
                                    {subscribePlans[0].Exchanges}
                                  </p>
                                </div>
                                <div className="bn-pln-dt-flx">
                                  <span className="bn-plan-check bn-plan-fr">
                                    <i className="fa-solid fa-check"></i>
                                  </span>

                                  <p className="bn-plan-details-content">
                                    <span className="bn-freemium">
                                      {t("ProfitSplit")}
                                    </span>{" "}
                                    {subscribePlans[0].SecondDistribution.user}
                                    (Users) +{" "}
                                    {subscribePlans[0].SecondDistribution.admin}
                                    (Admins)
                                  </p>
                                </div>
                                <div className="bn-pln-dt-flx">
                                  <span className="bn-plan-check bn-plan-fr">
                                    <i className="fa-solid fa-check"></i>
                                  </span>

                                  <p className="bn-plan-details-content">
                                    <span className="bn-freemium">
                                      {t("MinimumFuelBalanceRequired")}
                                    </span>{" "}
                                    {subscribePlans[0].min_fuel}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="bn_plan_nw_btn_wrap">
                            <Link
                              to={`${loginCheck ? "/upgrade" : "/register"}`}
                              className="ln_plan_link"
                            >
                              <button className="head-btn-login now_log bn_plan_btn_wd">
                                <span className="head-btn-login-now now_log">
                                  {t("StartFreeTrial")}
                                </span>
                                <span className="head-btn-login-new">
                                  {t("StartFreeTrial")}
                                </span>
                              </button>
                            </Link>
                            <Link
                              to={`${loginCheck ? "/upgrade" : "/register"}`}
                              className="ln_plan_link"
                            >
                              <button className="head-btn-login resp_100 bn_plan_btn_wd">
                                <span className="head-btn-login-now">
                                  {t("ActivateNow")}
                                </span>
                                <span className="head-btn-login-new">
                                  {t("ActivateNow")}
                                </span>
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="bn-plan-blue"></div>
                      <div className="bn-plan-orange"></div>
                    </div>
                  </div>

                  <div className="col-xl-5 col-md-6 bn-pn-col">
                    <div className="bn-pln-col">
                      <div className="bn-plan-card-outer">
                        <div className="bn-plan-card-inner">
                          <div>
                            <div className="text-center">
                              <img
                                src={require("../assests/premium.webp")}
                                alt="freemium"
                                className="bn-plan-card-img"
                              />
                            </div>
                            <h3 className="bn-pln-cd-title bn-premium">
                              {subscribePlans[1].subscriptionName}
                            </h3>
                            <div className="bn-pln-subtitle-wrap">
                              <h6 className="bn-pln-lft-title">
                                {parseFloat(
                                  subscribePlans[1].subscriptionAmount
                                ).toFixed(2)}{" "}
                                <span>
                                  {subscribePlans[1].subscriptionCurrency}/
                                  {t("Month")}
                                </span>
                              </h6>

                              {/* <p className="bn-pln-rgt-content">Free for 7 month</p> */}
                            </div>
                            <p className="bn-pln-rgt-content mt-3">
                              {" "}
                              {/* {t("AndCompliance")}{" "}
                              <span className="bn-premium">{t("Paddle")}</span>{" "}
                              {t("ProcessesAllPaymentsSecurely")} */}
                              {t("TrustAndCompliance")}
                              <br />
                              {/* {t("PaddleProcessesPayments")} */}
                            </p>
                            <div className="bn-pln-details-wrap">
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-pr">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-premium">
                                    {t("Strategies")}
                                  </span>{" "}
                                  {subscribePlans[1].Strategies}
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-pr">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-premium">
                                    {t("Exchanges")}
                                  </span>
                                  {subscribePlans[1].Exchanges}
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-pr">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-premium">
                                    {t("ProfitSplit")}
                                  </span>{" "}
                                  {subscribePlans[1].SecondDistribution.user}
                                  (Users) +{" "}
                                  {subscribePlans[1].SecondDistribution.admin}
                                  (Admin)
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-pr">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-premium">
                                    {t("ReferralOneTimeReward")} (
                                    {subscribePlans[1].subscriptionCurrency}):
                                  </span>{" "}
                                  {subscribePlans[1].referral_first}
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-pr">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-premium">
                                    {t("ReferralRewardForRecurringPayment")}{" "}
                                    (%):
                                  </span>{" "}
                                  {subscribePlans[1].referral_percentage}
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-pr">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-premium">
                                    {t("MinimumFuelBalanceRequired")}
                                  </span>{" "}
                                  {subscribePlans[1].min_fuel}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="bn_plan_nw_btn_wrap">
                            <Link
                              to={`${loginCheck ? "/upgrade" : "/register"}`}
                              className="ln_plan_link"
                            >
                              <button className="head-btn-login now_log bn_plan_btn_wd">
                                <span className="head-btn-login-now now_log">
                                  {t("StartFreeTrial")}
                                </span>
                                <span className="head-btn-login-new">
                                  {t("StartFreeTrial")}
                                </span>
                              </button>
                            </Link>
                            <Link
                              to={`${loginCheck ? "/upgrade" : "/register"}`}
                              className="ln_plan_link"
                            >
                              <button className="head-btn-login resp_100 bn_plan_btn_wd">
                                <span className="head-btn-login-now">
                                  {t("ActivateNow")}
                                </span>
                                <span className="head-btn-login-new">
                                  {t("ActivateNow")}
                                </span>
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="bn-plan-blue"></div>
                      <div className="bn-plan-orange"></div>
                    </div>
                  </div>

                  <div className="col-xl-5 col-md-6 bn-pn-col">
                    <div className="bn-pln-col">
                      <div className="bn-plan-card-outer">
                        <div className="bn-plan-card-inner">
                          <div>
                            <div className="text-center">
                              <img
                                src={require("../assests/promium.webp")}
                                alt="freemium"
                                className="bn-plan-card-img"
                              />
                            </div>
                            <h3 className="bn-pln-cd-title bn-promium">
                              {subscribePlans[2].subscriptionName}
                            </h3>

                            <div className="bn-pln-subtitle-wrap">
                              <h6 className="bn-pln-lft-title">
                                {parseFloat(
                                  subscribePlans[2].subscriptionAmount
                                ).toFixed(2)}{" "}
                                <span>
                                  {subscribePlans[2].subscriptionCurrency}/
                                  {t("Month")}
                                </span>
                              </h6>

                              {/* <p className="bn-pln-rgt-content">Free for 7 month</p> */}
                            </div>
                            <p className="bn-pln-rgt-content mt-3">
                              {" "}
                              {/* {t("AndCompliance")}{" "}
                              <span className="bn-promium">{t("Paddle")}</span>{" "}
                              {t("ProcessesAllPaymentsSecurely")} */}
                              {t("TrustAndCompliance")}
                              <br />
                              {/* {t("PaddleProcessesPayments")} */}
                            </p>

                            <div className="bn_pln_details_outer">
                              <div className="bn-pln-details-wrap">
                                <div className="bn-pln-dt-flx">
                                  <span className="bn-plan-check bn-plan-promium">
                                    <i className="fa-solid fa-check"></i>
                                  </span>

                                  <p className="bn-plan-details-content">
                                    <span className="bn-promium">
                                      {t("Strategies")}
                                    </span>{" "}
                                    {subscribePlans[2].Strategies}
                                  </p>
                                </div>
                                <div className="bn-pln-dt-flx">
                                  <span className="bn-plan-check bn-plan-promium">
                                    <i className="fa-solid fa-check"></i>
                                  </span>

                                  <p className="bn-plan-details-content">
                                    <span className="bn-promium">
                                      {t("Exchanges")}
                                    </span>
                                    {subscribePlans[2].Exchanges}
                                  </p>
                                </div>
                                <div className="bn-pln-dt-flx">
                                  <span className="bn-plan-check bn-plan-promium">
                                    <i className="fa-solid fa-check"></i>
                                  </span>

                                  <p className="bn-plan-details-content">
                                    <span className="bn-promium">
                                      {t("ProfitSplit")}
                                    </span>{" "}
                                    {subscribePlans[2].SecondDistribution.user}
                                    (Users) +{" "}
                                    {subscribePlans[2].SecondDistribution.admin}
                                    (Admin)
                                  </p>
                                </div>
                                <div className="bn-pln-dt-flx">
                                  <span className="bn-plan-check bn-plan-promium">
                                    <i className="fa-solid fa-check"></i>
                                  </span>

                                  <p className="bn-plan-details-content">
                                    <span className="bn-promium">
                                      {t("ReferralOneTimeReward")}(
                                      {subscribePlans[2].subscriptionCurrency}
                                      ):
                                    </span>{" "}
                                    {subscribePlans[2].referral_first}
                                  </p>
                                </div>
                                <div className="bn-pln-dt-flx">
                                  <span className="bn-plan-check bn-plan-promium">
                                    <i className="fa-solid fa-check"></i>
                                  </span>

                                  <p className="bn-plan-details-content">
                                    <span className="bn-promium">
                                      {t("ReferralRewardForRecurringPayment")}
                                      (%):
                                    </span>{" "}
                                    {subscribePlans[2].referral_percentage}
                                  </p>
                                </div>
                                <div className="bn-pln-dt-flx">
                                  <span className="bn-plan-check bn-plan-promium">
                                    <i className="fa-solid fa-check"></i>
                                  </span>

                                  <p className="bn-plan-details-content">
                                    <span className="bn-promium">
                                      {t("MinimumFuelBalanceRequired")}
                                    </span>{" "}
                                    {subscribePlans[2].min_fuel}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="bn_plan_nw_btn_wrap">
                            <Link
                              to={`${loginCheck ? "/upgrade" : "/register"}`}
                              className="ln_plan_link"
                            >
                              <button className="head-btn-login now_log bn_plan_btn_wd">
                                <span className="head-btn-login-now now_log">
                                  {t("StartFreeTrial")}
                                </span>
                                <span className="head-btn-login-new">
                                  {t("StartFreeTrial")}
                                </span>
                              </button>
                            </Link>
                            <Link
                              to={`${loginCheck ? "/upgrade" : "/register"}`}
                              className="ln_plan_link"
                            >
                              <button className="head-btn-login resp_100 bn_plan_btn_wd">
                                <span className="head-btn-login-now">
                                  {t("ActivateNow")}
                                </span>
                                <span className="head-btn-login-new">
                                  {t("ActivateNow")}
                                </span>
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="bn-plan-blue"></div>
                      <div className="bn-plan-orange"></div>
                    </div>
                  </div>

                  <div className="col-xl-5 col-md-6 bn-pn-col">
                    <div className="bn-pln-col">
                      <div className="bn-plan-card-outer">
                        <div className="bn-plan-card-inner">
                          <div>
                            <div className="text-center">
                              <img
                                src={require("../assests/promium.webp")}
                                alt="freemium"
                                className="bn-plan-card-img"
                              />
                            </div>
                            <h3 className="bn-pln-cd-title bn-promium">
                              {subscribePlans[3].subscriptionName}
                            </h3>
                            <div className="bn-pln-subtitle-wrap">
                              <h6 className="bn-pln-lft-title">
                                {parseFloat(
                                  subscribePlans[3].subscriptionAmount
                                ).toFixed(2)}{" "}
                                <span>
                                  {subscribePlans[3].subscriptionCurrency}/
                                  {t("Month")}
                                </span>
                              </h6>

                              {/* <p className="bn-pln-rgt-content">Free for 7 month</p> */}
                            </div>
                            <p className="bn-pln-rgt-content mt-3">
                              {" "}
                              {/* {t("AndCompliance")}{" "}
                              <span className="bn-promium">{t("Paddle")}</span>{" "}
                              {t("ProcessesAllPaymentsSecurely")} */}
                              {t("TrustAndCompliance")}
                              <br />
                              {/* {t("PaddleProcessesPayments")} */}
                            </p>
                            <div className="bn_pln_details_outer">
                              <div className="bn-pln-details-wrap">
                                <div className="bn-pln-dt-flx">
                                  <span className="bn-plan-check bn-plan-promium">
                                    <i className="fa-solid fa-check"></i>
                                  </span>

                                  <p className="bn-plan-details-content">
                                    <span className="bn-promium">
                                      {t("Strategies")}
                                    </span>{" "}
                                    {subscribePlans[3].Strategies}
                                  </p>
                                </div>
                                <div className="bn-pln-dt-flx">
                                  <span className="bn-plan-check bn-plan-promium">
                                    <i className="fa-solid fa-check"></i>
                                  </span>

                                  <p className="bn-plan-details-content">
                                    <span className="bn-promium">
                                      {t("Exchanges")}
                                    </span>
                                    {subscribePlans[3].Exchanges}
                                  </p>
                                </div>
                                <div className="bn-pln-dt-flx">
                                  <span className="bn-plan-check bn-plan-promium">
                                    <i className="fa-solid fa-check"></i>
                                  </span>

                                  <p className="bn-plan-details-content">
                                    <span className="bn-promium">
                                      {t("ProfitSplit")}
                                    </span>{" "}
                                    {subscribePlans[3].SecondDistribution.user}
                                    (Users) +{" "}
                                    {subscribePlans[3].SecondDistribution.admin}
                                    (Admin)
                                  </p>
                                </div>
                                <div className="bn-pln-dt-flx">
                                  <span className="bn-plan-check bn-plan-promium">
                                    <i className="fa-solid fa-check"></i>
                                  </span>

                                  <p className="bn-plan-details-content">
                                    <span className="bn-promium">
                                      {t("ReferralOneTimeReward")} (
                                      {subscribePlans[3].subscriptionCurrency}
                                      ):
                                    </span>{" "}
                                    {subscribePlans[3].referral_first}
                                  </p>
                                </div>
                                <div className="bn-pln-dt-flx">
                                  <span className="bn-plan-check bn-plan-promium">
                                    <i className="fa-solid fa-check"></i>
                                  </span>

                                  <p className="bn-plan-details-content">
                                    <span className="bn-promium">
                                      {t("ReferralRewardForRecurringPayment")}{" "}
                                      (%):
                                    </span>{" "}
                                    {subscribePlans[3].referral_percentage}
                                  </p>
                                </div>
                                <div className="bn-pln-dt-flx">
                                  <span className="bn-plan-check bn-plan-promium">
                                    <i className="fa-solid fa-check"></i>
                                  </span>

                                  <p className="bn-plan-details-content">
                                    <span className="bn-promium">
                                      {t("MinimumFuelBalanceRequired")}
                                    </span>{" "}
                                    {subscribePlans[3].min_fuel}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="bn_plan_nw_btn_wrap">
                            <Link
                              to={`${loginCheck ? "/upgrade" : "/register"}`}
                              className="ln_plan_link"
                            >
                              <button className="head-btn-login now_log bn_plan_btn_wd">
                                <span className="head-btn-login-now now_log">
                                  {t("StartFreeTrial")}
                                </span>
                                <span className="head-btn-login-new">
                                  {t("StartFreeTrial")}
                                </span>
                              </button>
                            </Link>
                            <Link
                              to={`${loginCheck ? "/upgrade" : "/register"}`}
                              className="ln_plan_link"
                            >
                              <button className="head-btn-login resp_100 bn_plan_btn_wd">
                                <span className="head-btn-login-now">
                                  {t("ActivateNow")}
                                </span>
                                <span className="head-btn-login-new">
                                  {t("ActivateNow")}
                                </span>
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="bn-plan-blue"></div>
                      <div className="bn-plan-orange"></div>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        </section>

        {/* affiliate */}
        <section className="bn_affiliate" id="affiliate-program">
          <div className="container-fluid container-lg">
            <h3 className="bn_ln_subtitle text-center">
              {t("BinargeAffiliateProgram")}
            </h3>
            <p className="bn_affiliate_cnt">
              {t("BinargeAffiliateDescription")}
            </p>

            <div className="row g-4 bn_af_row_one">
              <div className="col-xl-5 col-sm-6  text-center">
                <img
                  src={require("../assests/af_img_one.png")}
                  alt=""
                  className="bn_af_img"
                />
              </div>
              <div className="col-xl-7 col-sm-6 ">
                <div className="bn_af_card">
                  <h5>{t("OneTimeCommissionFirstOrder")} </h5>
                  <ul>
                    <li>{t("PremiumSubscriptionCommission")}</li>
                    <li>{t("PremiumEliteTradeSubscriptionCommission")}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="row g-4 bn_af_row_two">
              <div className="col-xl-7 col-sm-6  ">
                <div className="bn_af_card">
                  <h5>{t("OngoingCommissionOnRenewals")}</h5>
                  <ul>
                    <li>{t("OngoingCommissionDescription")}</li>
                    <li>{t("CommissionAutoCreditDescription")}</li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-5 col-sm-6  text-center">
                <img src={afImage[lang]} alt="" className="bn_af_img" />
              </div>
            </div>
          </div>
        </section>

        {/* affiliate terms */}
        <section className="bn_af_terms">
          <div className="container-fluid container-lg">
            <h3 className="bn_ln_subtitle text-center">
              {t("AffiliateTerms")}
            </h3>

            <div className="row g-4 bn_af_terms_row">
              <div className="col-lg-5 ">
                <img
                  src={require("../assests/affiliate_terms.webp")}
                  alt=""
                  className="bn_af_term_img"
                />
              </div>
              <div className="col-lg-7">
                <div className="accordion" id="accordionExample">
                  <div className="bn_af_ac_item">
                    <h2 className="bn_af_ac_header" id="headingOne">
                      <button
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        className="bn_af_ac_button"
                      >
                        <span>01</span>
                        {t("Introduction")}
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="bn_af_ac_body bn_af_ac_header">
                        {t("AffiliateTermsIntro")}
                      </div>
                    </div>
                  </div>

                  <div
                    className="bn_af_ac_item"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    <h2 className="bn_af_ac_header" id="headingTwo">
                      <button className="bn_af_ac_button collapsed">
                        <span>02</span>
                        {t("Eligibility")}
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="bn_af_ac_body">
                        {t("EligibilityRequirement")}
                      </div>
                    </div>
                  </div>

                  <div
                    className="bn_af_ac_item"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    <h2 className="bn_af_ac_header" id="headingThree">
                      <button className="bn_af_ac_button collapsed">
                        <span>03</span>
                        {t("HowItWorks")}
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="bn_af_ac_body">
                        {t("AffiliateReferralLinkDescription")}
                      </div>
                    </div>
                  </div>

                  <div
                    className="bn_af_ac_item"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    <h2 className="bn_af_ac_header" id="headingFour">
                      <button className="bn_af_ac_button collapsed">
                        <span>04</span>
                        {t("AffiliateRewardsOverview")}
                      </button>
                    </h2>
                    <div
                      id="collapseFour"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="bn_af_ac_body">
                        {/* {t("CommissionSummary")} */}
                        <ul>
                          <li>{t("PremiumSubscriptionAffiliate")}</li>
                          <li>{t("Premium&EliteTraderSubscription")}</li>
                          <li>{t("RecurringCommission")}</li>
                        </ul>
                        <p>{t("PremiumSubscriptionAffiliatePara")}</p>
                      </div>
                    </div>
                  </div>

                  <div
                    className="bn_af_ac_item"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                  >
                    <h2 className="bn_af_ac_header" id="headingFive">
                      <button className="bn_af_ac_button collapsed">
                        <span>05</span>
                        {/* {t("PayoutAndConditions")} */}
                        {t("PayoutPolicy")}
                      </button>
                    </h2>
                    <div
                      id="collapseFive"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFive"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="bn_af_ac_body">
                        {t("PayoutPolicyDescription")}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* why I create */}
        <section className="bn_af_why" id="about-us">
          <div className="container-fluid container-lg">
            <h3 className="bn_ln_subtitle text-center">
              {t("WhyICreatedBinarge")}
            </h3>
            <p className="bn_why_cnt">
              {t("WhyICreatedBinargeDescription")}{" "}
              {/* <span>
                “What if there was a way to create real value for users -
                without ever requiring them to hand over their assets?”
              </span> */}
            </p>

            <p className="bn_why_cnt text-center">
              {" "}
              <span>{t("ValueCreationQuote")}</span>
            </p>

            {/* Idea */}
            <div className="row g-4 bn_id_row">
              <div className="col-xl-7 col-lg-6">
                <h5 className="bn_id_title">
                  {t("FromIdeaToProductLogicFirst")}
                </h5>
                <p className="bn_id_content">{t("LogicFirstDescription")}</p>
                <p className="bn_id_content">{t("LogicFirstFollows")}</p>
                <p className="bn_id_content">{t("LogicFirstStarts")}</p>
                <h3 className="bn_id_title">{t("logicFirsttit")}</h3>
                <p className="bn_id_content">{t("LogicFirstfollow2")}</p>
                {/* <p className="bn_id_content">{t("VisionPartnerDescription")}</p> */}
                <p className="bn_id_content">{t("Automation")}</p>

                <p className="bn_id_content">{t("binarjefollow3")}</p>

                {/* <p className="bn_id_content">
                  {t("TogetherWeBuiltSystemWhere")}
                </p> */}

                <ul className="bn_id_lists">
                  <li>{t("AlgorithmBehaviorDescription")}</li>
                  <li> {t("ItDoesNotSleepHesitateOrGetGreedy")}</li>
                  <li>{t("NeverTouchesUsersFunds")}</li>
                  <li>{t("ApiDriven")}</li>
                </ul>
                <p className="bn_id_content">{t("ApiPassage")}</p>
                <div className="mistakes_no">
                <p className="bn_id_content">{t("nomistakes1")}</p>
                <p className="bn_id_content">{t("nomistakes2")}</p>
                <p className="bn_id_content">{t("nomistakes3")}</p>
                <p className="bn_id_content">{t("nomistakes4")}</p>
                </div>
                <p className="bn_id_title">{t("TurningClarityIntoConfidence")}</p>
                <p className="bn_id_content">{t("TurningClarityIntoConfidenceContent")}</p>
                <p className="bn_id_title">{t("Mymission")}</p>
                <p className="bn_id_content">{t("MissionContent")}</p>

              </div>
              <div className="col-xl-5 col-lg-6">
                <div className="bn_id_img_wrap">
                  <img src={require("../assests/idea_img_one.png")} alt="" />
                  <img
                    src={require("../assests/idea_img_two.webp")}
                    alt=""
                    className="bn_id_img_two"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* refund policy */}
        <div className="bn_af_refund">
          <div>
            <h3 className="bn_ln_subtitle text-center">
              {t("BinargeRefundPolicy")}
            </h3>
            <p className="bn_refund_cnt">{t("RefundPolicyDescription")}</p>

            <div className="bt_ref_swiper_outer">
              <div className="container-fluid container-xl">
                <Swiper
                  modules={[Navigation]}
                  navigation={{
                    prevEl: ".st_bt_tool_prev",
                    nextEl: ".st_bt_tool_nxt",
                  }}
                  breakpoints={{
                    320: {
                      slidesPerView: 1,
                      spaceBetween: 10,
                    },
                    480: {
                      slidesPerView: 1,
                      spaceBetween: 20,
                    },
                    768: {
                      slidesPerView: 2,
                      spaceBetween: 30,
                    },
                    1025: {
                      slidesPerView: 3,
                      spaceBetween: 40,
                    },
                    1200: {
                      slidesPerView: 3,
                      spaceBetween: 30,
                    },
                  }}
                  onSlideChange={handleToolsChange}
                  onReachBeginning={() => setIsPrevToolsDisabled(true)}
                  onReachEnd={() => setIsNextToolsDisabled(true)}
                  onFromEdge={() => {
                    setIsPrevToolsDisabled(false);
                    setIsNextToolsDisabled(false);
                  }}
                  speed={500}
                >
                  <SwiperSlide>
                    <div className="bn_refund_card">
                      <img
                        src={require("../assests/ref_img_one.webp")}
                        alt=""
                      />
                      <h5>{t("FirstTimePurchaseOnly")}</h5>
                      <p>{t("RefundsFirstTimeOnly")}</p>
                    </div>
                  </SwiperSlide>
                  {/* <SwiperSlide>
                    <div className="bn_refund_card">
                      <img
                        src={require("../assests/ref_img_two.webp")}
                        alt=""
                      />
                      <h5>{t("RefundsHandledByPaddle")}</h5>
                      <p>{t("PaymentProcessorDescription")}</p>
                    </div>
                  </SwiperSlide> */}
                  <SwiperSlide>
                    <div className="bn_refund_card">
                      <img
                        src={require("../assests/ref_img_three.webp")}
                        alt=""
                      />
                      <h5>{t("SevenDayRefundWindow")}</h5>
                      <p>{t("RefundsNotAvailableAfter7Days")}</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="bn_refund_card">
                      <img
                        src={require("../assests/ref_img_four.webp")}
                        alt=""
                      />
                      <h5>{t("NonCustodialPlatformNotice")}</h5>
                      <p>{t("NonCustodialPlatformDescription")}</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="bn_refund_card">
                      <img
                        src={require("../assests/ref_img_five.webp")}
                        alt=""
                      />
                      <h5>{t("HowToRequestRefund")}</h5>
                      <p>{t("emailland")}</p>
                    </div>
                  </SwiperSlide>
                </Swiper>

                <div className="bn-ref-btn-wrap">
                  <button
                    className={`st_bt_tool_prev ${isPrevToolsDisabled ? "disabled" : ""
                      }`}
                    style={{
                      color: isPrevToolsDisabled ? "#ffffff90" : "#ffffff",
                      cursor: isPrevToolsDisabled ? "not-allowed" : "pointer",
                    }}
                  >
                    <i className="fa-solid fa-arrow-left"></i>
                  </button>

                  <button
                    className={`st_bt_tool_nxt ${isNextToolsDisabled ? "disabled" : ""
                      }`}
                    style={{
                      color: isNextToolsDisabled ? "#ffffff90" : "#ffffff",
                      cursor: isNextToolsDisabled ? "not-allowed" : "pointer",
                    }}
                  >
                    <i className="fa-solid fa-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ */}
        <div className="bn_faq_container">
          <div className="container-fluid container-xl">
            <h3 className="bn_ln_subtitle text-center">
              {t("FAQBinargeArbitrageBot")}
            </h3>

            <div className="row bn_fq_row">
              <div className="col-lg-6">
                <div className="bn_faq_wrap">
                  <div
                    class="accordion accordion-flush bn_faq_accordion"
                    id="accordionFlushExample"
                  >
                    <div class="bn_faq_item">
                      <h2 class="bn_af_ac_header" id="flush-headingOne">
                        <button
                          class="bn_ln_faq_button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseOne"
                          aria-expanded="false"
                          aria-controls="flush-collapseOne"
                        >
                          {t("WhatIsBinargeBot1")}
                        </button>
                      </h2>
                      <div
                        id="flush-collapseOne"
                        class="accordion-collapse collapse"
                        aria-labelledby="flush-headingOne"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div class="bn_af_ac_body">
                          {t("BinargeArbitrageBotDescription")}
                        </div>
                      </div>
                    </div>
                    <div class="bn_faq_item">
                      <h2 class="bn_af_ac_header" id="flush-headingTwo">
                        <button
                          class="bn_ln_faq_button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseTwo"
                          aria-expanded="false"
                          aria-controls="flush-collapseTwo"
                        >
                          {t("IsBinargeAnInvestmentPlatform")}
                        </button>
                      </h2>
                      <div
                        id="flush-collapseTwo"
                        class="accordion-collapse collapse"
                        aria-labelledby="flush-headingTwo"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div class="bn_af_ac_body">
                          {t("IsBinargeAnInvestmentPlatformAnswer")}
                        </div>
                      </div>
                    </div>
                    <div class="bn_faq_item">
                      <h2 class="bn_af_ac_header" id="flush-headingThree">
                        <button
                          class="bn_ln_faq_button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseThree"
                          aria-expanded="false"
                          aria-controls="flush-collapseThree"
                        >
                          {t("HowDoesBinargeBotWork")}
                        </button>
                      </h2>
                      <div
                        id="flush-collapseThree"
                        class="accordion-collapse collapse"
                        aria-labelledby="flush-headingThree"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div class="bn_af_ac_body">
                          {/* {t("HowBinargeBotWorksDescription")} */}
                          <h5 className="bot-practice">{t("createyourBinargeaccount")}</h5>
                          <p>{t("createYourAccountOnBinargedes")}</p>
                          <h5 className="bot-practice">{t("AddASmallAmount")}</h5>
                          <p>{t("smallAmountdes")}</p>
                          <h5 className="bot-practice">{t("ChooseYourSubscriptionModel")}</h5>
                          <p>{t("subscriptionkeytypes")}</p>
                          <h5 className="bot-practice">{t("tradingAcceptance")}</h5>
                          <p>{t("enableAcceptance")}</p>
                          <h5 className="bot-practice">{t("reviewAccept")}</h5>
                          <p>{t("reviewfollows")}</p>
                          <ul><li>{t("ppList1")}</li></ul>
                          <ul><li>{t("ppList2")}</li></ul>
                          <ul><li>{t("ppList3")}</li></ul>
                          <ul><li>{t("ppList4")}</li></ul>
                          <ul><li>{t("ppList5")}</li></ul>
                          <h5 className="bot-practice">{t("Apiready")}</h5>
                          <p>{t("ConnectYourAPIKeys")}</p>
                          <h5 className="bot-practice">{t("Activatethebot")}</h5>
                          <p>{t("ActivateTheBotItWillStartTradingAutomatically")}</p>
                          <p>{t("AllProfitsGoDirectlyToYourOwnExchange")}</p>



                        </div>
                      </div>
                    </div>
                    <div class="bn_faq_item">
                      <h2 class="bn_af_ac_header" id="flush-headingFour">
                        <button
                          class="bn_ln_faq_button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseFour"
                          aria-expanded="false"
                          aria-controls="flush-collapseFour"
                        >
                          {t("WhatStrategiesDoesBotUse")}
                        </button>
                      </h2>
                      <div
                        id="flush-collapseFour"
                        class="accordion-collapse collapse"
                        aria-labelledby="flush-headingFour"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div class="bn_af_ac_body">
                          {t("BotStrategiesDescription")}
                        </div>
                      </div>
                    </div>
                    <div class="bn_faq_item">
                      <h2 class="bn_af_ac_header" id="flush-headingFive">
                        <button
                          class="bn_ln_faq_button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseFive"
                          aria-expanded="false"
                          aria-controls="flush-collapseFive"
                        >
                          {t("DoINeedTradingExperience")}
                        </button>
                      </h2>
                      <div
                        id="flush-collapseFive"
                        class="accordion-collapse collapse"
                        aria-labelledby="flush-headingFive"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div class="bn_af_ac_body">
                          {t("DoINeedTradingExperienceAnswer")}
                        </div>
                      </div>
                    </div>
                    <div class="bn_faq_item">
                      <h2 class="bn_af_ac_header" id="flush-headingSix">
                        <button
                          class="bn_ln_faq_button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseSix"
                          aria-expanded="false"
                          aria-controls="flush-collapseSix"
                        >
                          {t("IsItSafeToUseBinarge")}
                        </button>
                      </h2>
                      <div
                        id="flush-collapseSix"
                        class="accordion-collapse collapse"
                        aria-labelledby="flush-headingSix"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div class="bn_af_ac_body">
                          {t("IsItSafeToUseBinargeAnswer")}
                        </div>
                      </div>
                    </div>
                    <div class="bn_faq_item">
                      <h2 class="bn_af_ac_header" id="flush-headingSeven">
                        <button
                          class="bn_ln_faq_button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseSeven"
                          aria-expanded="false"
                          aria-controls="flush-collapseSeven"
                        >
                          {t("HowQuicklyReceiveProfits")}
                        </button>
                      </h2>
                      <div
                        id="flush-collapseSeven"
                        class="accordion-collapse collapse"
                        aria-labelledby="flush-headingSeven"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div class="bn_af_ac_body">
                          {t("ProfitsDescription")}
                        </div>
                      </div>
                    </div>
                    <div class="bn_faq_item">
                      <h2 class="bn_af_ac_header" id="flush-headingEight">
                        <button
                          class="bn_ln_faq_button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseEight"
                          aria-expanded="false"
                          aria-controls="flush-collapseEight"
                        >
                          {t("HowSubscriptionModelsWork")}
                        </button>
                      </h2>
                      <div
                        id="flush-collapseEight"
                        class="accordion-collapse collapse"
                        aria-labelledby="flush-headingEight"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div class="bn_af_ac_body">
                          {/* {t("SubscriptionModelsDescription")} */}
                          <p>{t("BinargeOffersFourSubscriptionLevels")}</p>
                          <ul>
                            <li>{t("FreemiumFree")}</li>
                            <li>{t("PremiumMonth")}</li>
                            <li>{t("PremiumPlus")}</li>
                            <li>{t("EliteTraderMonth")}</li>
                          </ul>
                          <p>
                            {t(
                              "AllSubscriptionPlansIncludeAPerformanceFeeModel"
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="bn_faq_item">
                      <h2 class="bn_af_ac_header" id="flush-headingNine">
                        <button
                          class="bn_ln_faq_button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseNine"
                          aria-expanded="false"
                          aria-controls="flush-collapseNine"
                        >
                          {t("CanITryBinargeForFree")}
                        </button>
                      </h2>
                      <div
                        id="flush-collapseNine"
                        class="accordion-collapse collapse"
                        aria-labelledby="flush-headingNine"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div class="bn_af_ac_body">
                          {t("CanITryBinargeForFreeAnswer")}
                        </div>
                      </div>
                    </div>
                    <div class="bn_faq_item">
                      <h2 class="bn_af_ac_header" id="flush-headingTen">
                        <button
                          class="bn_ln_faq_button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseTen"
                          aria-expanded="false"
                          aria-controls="flush-collapseTen"
                        >
                          {t("CanIUseMultipleStrategiesAtSameTime")}
                        </button>
                      </h2>
                      <div
                        id="flush-collapseTen"
                        class="accordion-collapse collapse"
                        aria-labelledby="flush-headingTen"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div class="bn_af_ac_body">
                          {t("CanUseMultipleStrategiesAnswer")}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="bn_faq_wrap bn_faq_wrap_two">
                  <div
                    class="accordion accordion-flush bn_faq_accordion"
                    id="accordionFlushExample"
                  >
                    <div class="bn_faq_item">
                      <h2 class="bn_af_ac_header" id="flush-headingEleven">
                        <button
                          class="bn_ln_faq_button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseEleven"
                          aria-expanded="false"
                          aria-controls="flush-collapseEleven"
                        >
                          {t("HowDoesFuelWalletWork")}
                        </button>
                      </h2>
                      <div
                        id="flush-collapseEleven"
                        class="accordion-collapse collapse"
                        aria-labelledby="flush-headingEleven"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div class="bn_af_ac_body">
                          {t("FuelWalletProfitSharingDescription")}
                        </div>
                      </div>
                    </div>
                    <div class="bn_faq_item">
                      <h2 class="bn_af_ac_header" id="flush-headingTwelve">
                        <button
                          class="bn_ln_faq_button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseTwelve"
                          aria-expanded="false"
                          aria-controls="flush-collapseTwelve"
                        >
                          {t("HowDoesBinargeManageRisks")}
                        </button>
                      </h2>
                      <div
                        id="flush-collapseTwelve"
                        class="accordion-collapse collapse"
                        aria-labelledby="flush-headingTwelve"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div class="bn_af_ac_body">
                          {t("RiskManagementDescription")}
                        </div>
                      </div>
                    </div>
                    <div class="bn_faq_item">
                      <h2 class="bn_af_ac_header" id="flush-headingThirteen">
                        <button
                          class="bn_ln_faq_button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseThirteen"
                          aria-expanded="false"
                          aria-controls="flush-collapseThirteen"
                        >
                          {t("WhichCryptoExchangesSupported")}
                        </button>
                      </h2>
                      <div
                        id="flush-collapseThirteen"
                        class="accordion-collapse collapse"
                        aria-labelledby="flush-headingThirteen"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div class="bn_af_ac_body">
                          {t("SupportedExchangesDescription")}
                        </div>
                      </div>
                    </div>
                    <div class="bn_faq_item">
                      <h2 class="bn_af_ac_header" id="flush-headingFourteen">
                        <button
                          class="bn_ln_faq_button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseFourteen"
                          aria-expanded="false"
                          aria-controls="flush-collapseFourteen"
                        >
                          {t("HowReferralProgramWorks")}
                        </button>
                      </h2>
                      <div
                        id="flush-collapseFourteen"
                        class="accordion-collapse collapse"
                        aria-labelledby="flush-headingFourteen"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div class="bn_af_ac_body">
                          {t("ReferralEarningsDescription")}
                        </div>
                      </div>
                    </div>
                    <div class="bn_faq_item">
                      <h2 class="bn_af_ac_header" id="flush-headingFifteen">
                        <button
                          class="bn_ln_faq_button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseFifteen"
                          aria-expanded="false"
                          aria-controls="flush-collapseFifteen"
                        >
                          {t("NeedColdWalletQuestion")}
                        </button>
                      </h2>
                      <div
                        id="flush-collapseFifteen"
                        class="accordion-collapse collapse"
                        aria-labelledby="flush-headingFifteen"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div class="bn_af_ac_body">
                          {t("ColdWalletExplanation")}
                        </div>
                      </div>
                    </div>
                    <div class="bn_faq_item">
                      <h2 class="bn_af_ac_header" id="flush-headingSixteen">
                        <button
                          class="bn_ln_faq_button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseSixteen"
                          aria-expanded="false"
                          aria-controls="flush-collapseSixteen"
                        >
                          {t("EarningsWithBinargeQuestion")}
                        </button>
                      </h2>
                      <div
                        id="flush-collapseSixteen"
                        class="accordion-collapse collapse"
                        aria-labelledby="flush-headingSixteen"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div class="bn_af_ac_body">
                          {t("EarningsWithBinargeExplanation")}
                        </div>
                      </div>
                    </div>
                    <div class="bn_faq_item">
                      <h2 class="bn_af_ac_header" id="flush-headingSeventeen">
                        <button
                          class="bn_ln_faq_button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseSeventeen"
                          aria-expanded="false"
                          aria-controls="flush-collapseSeventeen"
                        >
                          {t("WhereToGetHelpQuestion")}
                        </button>
                      </h2>
                      <div
                        id="flush-collapseSeventeen"
                        class="accordion-collapse collapse"
                        aria-labelledby="flush-headingSeventeen"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div class="bn_af_ac_body">
                          {t("CustomerSupportDescription")}
                        </div>
                      </div>
                    </div>
                    <div class="bn_faq_item">
                      <h2 class="bn_af_ac_header" id="flush-headingEighteen">
                        <button
                          class="bn_ln_faq_button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseEighteen"
                          aria-expanded="false"
                          aria-controls="flush-collapseEighteen"
                        >
                          {t("ProfitSharingTitle")}
                        </button>
                      </h2>
                      <div
                        id="flush-collapseEighteen"
                        class="accordion-collapse collapse"
                        aria-labelledby="flush-headingEighteen"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div class="bn_af_ac_body">
                          {/* {t("ProfitSharingDescription")}{" "} */}
                          <p>{t("BinargeUsesAPerformance")}</p>
                          <p>{t("FeeDistributionBySubscriptionLevel")}</p>
                          <ul>
                            <li>{t("FreemiumUser")}</li>
                            <li>{t("PremiumUser")}</li>
                            <li>{t("PromiumUser")}</li>
                            <li>{t("EliteTraderUser")}</li>
                          </ul>
                          <p>{t("ParaUser")}</p>
                        </div>
                      </div>
                    </div>
                    <div class="bn_faq_item">
                      <h2 class="bn_af_ac_header" id="flush-headingNineteen">
                        <button
                          class="bn_ln_faq_button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseNineteen"
                          aria-expanded="false"
                          aria-controls="flush-collapseNineteen"
                        >
                          {t("CancelSubscriptionQuestion")}
                        </button>
                      </h2>
                      <div
                        id="flush-collapseNineteen"
                        class="accordion-collapse collapse"
                        aria-labelledby="flush-headingNineteen"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div class="bn_af_ac_body">
                          {t("CancelSubscriptionExplanation")}
                        </div>
                      </div>
                    </div>
                    <div class="bn_faq_item">
                      <h2 class="bn_af_ac_header" id="flush-headingTwenty">
                        <button
                          class="bn_ln_faq_button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseTwenty"
                          aria-expanded="false"
                          aria-controls="flush-collapseTwenty"
                        >
                          {t("InstructionsQuestion")}
                        </button>
                      </h2>
                      <div
                        id="flush-collapseTwenty"
                        class="accordion-collapse collapse"
                        aria-labelledby="flush-headingTwenty"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div class="bn_af_ac_body">
                          {t("InstructionsAnswer")}{" "}
                          <a
                            target="_blank"
                            href="https://www.youtube.com/@binargebot"
                          >
                            https://www.youtube.com/@binargebot
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* footer  */}
        <Footer />
        <Chatbot />
      </main>

      {/* <div className="cookies_wrap">
        <CookieConsent
          location="bottom"
          buttonText="Accept Cookies"
          cookieName="myAwesomeCookieName2"
          buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
          expires={150}
        >
          <div>
            <p className="cookies_content">
              We use cookies to ensure the best possible experience. By using
              our site you agree with our{" "}
              <a
                href="/privacy-cookies-policy"
                target="_blank"
                className="cookies_link"
              >
                Cookie Policy
              </a>
            </p>
          </div>
        </CookieConsent>
      </div> */}
    </>
  );
};

export default LandingNew2;
